export const SUPPORTED_TIMEFRAMES: string[] = ['5','15','30','60','240','720','D','W','M']

